/**
 * Single source of truth for headline statistics displayed across the site.
 *
 * If you change a number here, every consumer (StatsStrip, ExploreSection
 * "Historical Gallery" card, HistoricalGalleryPage hero subtitle, and any
 * meta description / JSON-LD) updates automatically.
 *
 * `archivalPhotos` is derived from the auto-generated archival photo index —
 * every `.asset.json` image pointer under `public/` and `src/assets/`, minus
 * UI/logo/og assets. Regenerate with:
 *   node scripts/build-archival-photos-index.mjs
 */
import { ARCHIVAL_PHOTOS_COUNT } from '@/generated/archival-photos-count';

export const SITE_STATS = {
  yearsOfHumanHistory: 10000,
  yearsSinceFounding: 146,
  peakAcres: 566000,
  longhornsTrailedToDodgeCity: 300000,
  archivalPhotos: ARCHIVAL_PHOTOS_COUNT,
  schreinerGenerations: 5,
  exoticSpecies: 56,
} as const;

export type SiteStats = typeof SITE_STATS;
